import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { EffectR } from 'types/utils';
import { ActionType } from 'typesafe-actions';
import { getArticle } from 'common/selectors';
import {
  cancelDislikeForReview,
  cancelLikeForReview,
  changeDislikeToLikeForReview,
  changeLikeToDislikeForReview,
  setDislikeForReview,
  setLikeForReview,
  setVoterId,
} from '../actions';
import { getLikeDislikeVoterId } from '../selectors';
import { cancelReviewsOpinion, postReviewsOpinion } from '../utils/api';
import { generateVoterId, restoreVoterId, storeVoterId } from '../utils/get-voter-id';

export function* reviewsLikeDislikeSagas() {
  yield takeEvery(setVoterId, doStoreVoterId);
  yield call(doRestoreVoterId);

  yield all([
    takeEvery(setLikeForReview, doSetLikeForReview),
    takeEvery(cancelLikeForReview, doCancelLikeForReview),

    takeEvery(setDislikeForReview, doSetDislikeForReview),
    takeEvery(cancelDislikeForReview, doCancelDislikeForReview),

    takeEvery(changeLikeToDislikeForReview, doChangeLikeToDislikeForReview),
    takeEvery(changeDislikeToLikeForReview, doChangeDislikeToLikeForReview),
  ]);
}

export function* doChangeDislikeToLikeForReview(action: ActionType<typeof changeDislikeToLikeForReview>) {
  const productId = yield* selectProductId();
  const voterId = yield* selectLikeDislikeVoterId();
  if (voterId) {
    yield call(cancelReviewsOpinion, action.payload, voterId, 'dislike', productId);
    yield call(postReviewsOpinion, action.payload, voterId, 'like', productId);
  }
}

export function* doChangeLikeToDislikeForReview(action: ActionType<typeof changeLikeToDislikeForReview>) {
  const productId = yield* selectProductId();
  const voterId = yield* selectLikeDislikeVoterId();
  if (voterId) {
    yield call(cancelReviewsOpinion, action.payload, voterId, 'like', productId);
    yield call(postReviewsOpinion, action.payload, voterId, 'dislike', productId);
  }
}

export function* doSetLikeForReview(action: ActionType<typeof setLikeForReview>) {
  const productId = yield* selectProductId();
  const voterId = yield* selectLikeDislikeVoterId();
  if (voterId) {
    yield call(postReviewsOpinion, action.payload, voterId, 'like', productId);
  }
}

export function* doSetDislikeForReview(action: ActionType<typeof setDislikeForReview>) {
  const productId = yield* selectProductId();
  const voterId = yield* selectLikeDislikeVoterId();
  if (voterId) {
    yield call(postReviewsOpinion, action.payload, voterId, 'dislike', productId);
  }
}

export function* doCancelLikeForReview(action: ActionType<typeof cancelLikeForReview>) {
  const productId = yield* selectProductId();
  const voterId = yield* selectLikeDislikeVoterId();
  if (voterId) {
    yield call(cancelReviewsOpinion, action.payload, voterId, 'like', productId);
  }
}

export function* doCancelDislikeForReview(action: ActionType<typeof cancelDislikeForReview>) {
  const productId = yield* selectProductId();
  const voterId = yield* selectLikeDislikeVoterId();
  if (voterId) {
    yield call(cancelReviewsOpinion, action.payload, voterId, 'dislike', productId);
  }
}

export function* doRestoreVoterId() {
  let voterId: string | null = yield call(restoreVoterId);
  if (voterId === null) {
    voterId = yield call(generateVoterId);
  }
  yield put(setVoterId(voterId));
}

export function* doStoreVoterId(action: ActionType<typeof setVoterId>) {
  yield call(storeVoterId, action.payload);
}

function* selectLikeDislikeVoterId() {
  return (yield select(getLikeDislikeVoterId)) as EffectR.Select<typeof getLikeDislikeVoterId>;
}

function* selectProductId() {
  return (yield select(getArticle)) as EffectR.Select<typeof getArticle>;
}
